import * as braze from '@braze/web-sdk';
import { UsersData } from '../reducers/common/user-data';

// init Braze SDK config
interface BrazeConfig {
    apiKey: string;
    baseUrl: string;
    enableLogging?: boolean;
    user?: UsersData;
}

// Helper function to validate required config
const isValidConfig = (config: BrazeConfig): boolean => {

    return !!(config.user?.id && config.apiKey && config.baseUrl);
};

// Helper function to setup user attributes
const setupUserAttributes = (user: UsersData): void => {
    const brazeUser = braze.getUser();
    if (!brazeUser) return;

    brazeUser.setFirstName(user.firstName);
    brazeUser.setLastName(user.lastName);
    brazeUser.setEmail(user.email);
    brazeUser.setPhoneNumber(user.phoneNumber);
};

// Helper function to initialize and setup user
const initializeAndSetupUser = (config: BrazeConfig): void => {
    braze.initialize(config.apiKey, {
        baseUrl: config.baseUrl,
        enableLogging: config.enableLogging || false,
    });

    const userId = braze.getUser()?.getUserId();
    const targetUserId = String(config.user!.id);

    if (userId !== targetUserId) {
        braze.changeUser(targetUserId);
        setupUserAttributes(config.user!);
    }
};

// Initialize Braze instance
export const initBraze = (config: BrazeConfig): braze.BrazeSdkMetadata | null => {
    try {
        if (!isValidConfig(config)) {
            return null;
        }

        initializeAndSetupUser(config);
        console.log('Braze SDK initialized successfully');
        return braze;
    } catch (error) {
        console.error('Failed to initialize Braze SDK:', error);
        return null;
    }
};
